import { useTranslation } from 'react-i18next'

import { Clock, X } from '@phosphor-icons/react'

import { Button, Checkbox, Text } from '@reveni-io/reveni-ui'

import TimeRangeSelector from './TimeRangeSelector/TimeRangeSelector'
import * as Styles from './styles'

const AddTimeRanges = ({
  timeRanges = [],
  onAdd,
  onRemove,
  onChange,
  isCarrierConnected,
  supportsPickupDate,
  onChangeSupportsPickupDate,
  supportsTimeRanges,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('Programar recogida')}</Text>
      {!isCarrierConnected && (
        <Checkbox
          label={t('Permitir al cliente elegir el día y hora de recogida en el portal')}
          onChange={onChangeSupportsPickupDate}
          defaultChecked={supportsPickupDate}
        />
      )}
      {(supportsPickupDate || (isCarrierConnected && supportsTimeRanges)) && (
        <>
          <Text type="bodyMRegular">
            {t(
              'Define las franjas horarias que se le mostrarán al cliente en el portal para que pueda escoger el dia y hora más convenientes para que se recojan los productos.'
            )}
          </Text>
          {timeRanges?.map(tr => (
            <Styles.TimeRangesContainer key={tr.id}>
              <TimeRangeSelector
                label={t('Desde las')}
                value={tr.start}
                onChange={value => onChange(tr.id, value, 'start')}
              />
              <TimeRangeSelector
                label={t('Hasta las')}
                value={tr.end}
                onChange={value => onChange(tr.id, value, 'end')}
              />
              <X size={55} weight="light" alt="remove" onClick={() => onRemove(tr.id)} />
            </Styles.TimeRangesContainer>
          ))}
          <div>
            <Button variant="text" onClick={onAdd}>
              <Clock size={24} />
              {t('Añadir franja horaria')}
            </Button>
          </div>
        </>
      )}
    </Styles.Container>
  )
}

export default AddTimeRanges
